<!-- 该效果是首页随着轮播图展示的标题动画 -->
 <!-- 实现方式：切换时，上一张关闭，下一张打开-->
<template>
  <div v-if="isPc">
  <transition  
    name="custom-classes-transition"
    enter-active-class="animated fadeIn" 
    leave-active-class="animated fadeOut">  
    <div :class="{'divBox1': id==1,'divBox2': id==2,'divBox3': id==3}" ref="ref1"   v-if="showDivFlag" >
    <el-row type="flex" justify="center">
       <el-col :span=17>
        <div class="text-center" >
          <div :class="{'animated fadeIn': fontShow1 }"  v-if="fontShow1" >
                <h1 v-if="id==1" class="h1">智能装备</h1>
                <h1 v-else-if="id==2" class="h1">物料逐支跟踪系统</h1>
                <h1 v-else-if="id==3" class="h1">智能化集控中心</h1>
        </div>
      <div :class="{'animated fadeIn': fontShow2 }"  v-if="fontShow2" style="margin-top:-30px" >
        <h6 class="white-color font-24"  style="font-weight:400;line-height:1.8em" v-if="id==1">自主研发的智能装备，实现产品自动打磨、尺寸、平直度、内表面缺陷及外表面缺陷等产品质量的全面自动化检测，提高质量管控水平，杜绝产品质量缺陷外发风险，并实现减员增效。</h6>
        <h6 class="white-color font-24"  style="font-weight:400;line-height:1.8em" v-else-if="id==2">提供基于机器视觉+智能标识+AI识别的物料逐支跟踪系统的软硬件一体化整体解决方案，并首创实现了无缝钢管生产全流程的物料逐支跟踪，解决了多年的行业共有技术瓶颈和卡脖子难题，树立了国内外无缝钢管行业智能工厂的最高水准。</h6>
        <h6 class="white-color font-24"  style="font-weight:400;line-height:1.8em" v-else-if="id==3">作为工厂运行大脑，面向全线多工序远程操作的集约管理，实现多业务、多部门的一体化高效协同和智能决策。</h6>
      </div>
       <div :class="{'animated fadeIn': fontShow3 }"  v-if="fontShow3" style="margin-top:-30px">
         <h6 class="white-color font-24"  style="font-weight:400;line-height:1.8em" v-if="id==2"></h6>
      </div>
      <div class="animated fadeIn flex-box-center"  :style="[{'margin-top': id === 2 ? '-20px':'80px'}]" >
          <div class="btnbutton flex-box-center" @click="btnDivJump">
              <span>查看详情</span>
          </div>
      </div>
      </div>
       </el-col>
    </el-row>
   </div>
   </transition>  
  </div>
   <!-- 手机端样式-->
 <div v-else> 
  <transition  
    name="custom-classes-transition"
    enter-active-class="animated zoomInDown" 
    leave-active-class="animated rotateOut">  
    <div :class="{'divMobileBox1': id==1,'divMobileBox2': id==2,'divMobileBox3': id==3}" ref="ref1"   v-if="showDivFlag" >
      <el-row type="flex" justify="center">
        <el-col :span=18>
        <div class="divBoxMobileItem"  :class="{'animated zoomIn': fontShow1 }"  v-if="fontShow1" >
          <strong class="white-color" >
            <h1 v-if="id==1" class="h1">智能装备</h1>
            <h1 v-else-if="id==2" class="h1">物料逐支跟踪系统</h1>
            <h1 v-else-if="id==3" class="h1">智能化集控中心</h1>
          </strong>
        </div>
        <div :class="{'animated zoomIn': fontShow2 }"  v-if="fontShow2" >
          <p class="font-30 white-color"  v-if="id==1">自主研发的智能装备，实现产品自动打磨、尺寸、平直度、内表面缺陷及外表面缺陷等产品质量的全面自动化检测，提高质量管控水平，杜绝产品质量缺陷外发风险，并实现减员增效。</p>
          <p class="font-30 white-color"  v-else-if="id==2">提供基于机器视觉+智能标识+AI识别的物料逐支跟踪系统的软硬件一体化整体解决方案，并首创实现了无缝钢管生产全流程的物料逐支跟踪，解决了多年的行业共有技术瓶颈和卡脖子难题，树立了国内外无缝钢管行业智能工厂的最高水准。</p>
          <p class="font-30 white-color"  v-else-if="id==3">作为工厂运行大脑，面向全线多工序远程操作的集约管理，实现多业务、多部门的一体化高效协同和智能决策。</p>
        </div>
      </el-col>
      </el-row>
   </div>
   </transition>  
  </div>
</template>

<script>
export default {
  name:'BannerTitle',
  data(){
        return{
              showDivFlag:false,
              fontShow1:false,
              fontShow2:false,
              fontShow3:false,
              isPc:true,
        }
  },
  props:{
     id:{
         type:Number,
         default:1
     }
  },
  watch:{
     id(newVal,oldVal){
        if(newVal!=oldVal)
         {
             this.handleFlag();
         }
     }
  },
  created(){
      this.isPc=this.$store.state.isPc;
      this.handleFlag();
  },
  methods:{
      sleep(delay){
            return function(){
            return new Promise(function(resolve, reject){
              setTimeout(resolve, delay);
            });
     }
  },
   btnDivJump(){
       var path="";
       if(this.id==1)
       {
        path="/ProductPolish";
       }
       else if(this.id==2)
        {
          path="/ProductTrack"
        }
         else if(this.id==3)
        {
          path="/ProductControl"
        }
         this.$router.push({
            path:path,
       })
     },
   handleFlag(){
      this.fontShow1=false;
      this.fontShow2=false;
      this.fontShow3=false;
      this.showDivFlag=false;
      this.fontShow1=true;
      this.fontShow2=true;
      this.fontShow3=true;
      this.showDivFlag=true;
    }
  }
}
</script>

<style scoped>
.btnbutton{
  color:#fff;
  width:185px;
  height:56px;
  font-size:20px;
  border-radius:160px;
  border: 2px solid #fff;
}

 .btnbutton:hover   {
    cursor: pointer;
    background:rgba(255,255,255,0.2);
} 

 .h1{
  font-size:54px;
  margin-bottom:25px;
  font-weight:700;
  letter-spacing: 3px;
  color:rgb(221, 217, 217);
 }
  .divBox1{
     width:100% ;
     height: 200px;
     position: absolute;
     top:20%;
       /* left: 15%;   */
     z-index: 2;
  }
  .divBox2{
    width:100% ;
    height: 200px;
    position: absolute;
    top:20%;
    /* left: 17%;   */
    z-index: 2;
  }
  .divBox3{
       width:100% ;
     height: 200px;
    position: absolute;
    top:20%;
    /* left: 17%;   */
    z-index: 2;
  }
 
  .divMobileBox1{
    width:100% ;
    /* background-color:#1C5A83; */
    position: absolute;
       top:200px;
    z-index: 2;
  }

  .divMobileBox2{
     width:100% ;
    /* background-color:#1C5A83; */
    position: absolute;
     top:200px;
    z-index: 2;
  }
  
  .divMobileBox3{
      width:100% ;
    /* background-color:#1C5A83; */
    position: absolute;
      top:200px;
    z-index: 2;
  }
  .divBoxMobileItem{
   margin-top:10px;
}
</style>

